import {
    SET_DAYS_LIST,
    SET_CURRENT_DAY,
    SET_INTERVENTIONS,
    SET_ORDER_BY,
    SET_CURRENT_INTERVENTION,
    SET_SELECTED_DISPLAY_MODE,
    SET_INTERVENTIONS_BLOC_TYPES,
    SET_BLOCS,
    SET_PREVIEW,
    SET_SIGNATURE,
    SET_CURRENT_TIME_SLOT,
    SET_IMPUTATION_REDIRECTION,
    SET_DISPLAY_ENDED_INTERVENTIONS,
    SET_BLOCS_HEIGHT,
    SET_FILTERED_AND_SORTED_INTERVENTIONS,
    SET_SELECTED_DAY,
    SET_DISPLAY_ONLY_IF_GOT_CERFA,
    SET_UPDATING_BLOC,
    SET_SELECTED_TECHNICIAN_ID,
    SET_EXPANDED_BLOC,
    SEARCH_BY_INTERVENTION_NUMBER,
    SET_CONTROL_SIGNATURE,
} from "./interventionConstants";
import { setValue } from "../../lib/immutable_wrapper";
import { getDisplayModes, getSortingModes } from "./interventionSortAndFilter";
import moment from "moment";
import { ALL_SELECT_OPTION } from "../../constants";
moment.locale("fr");

const initialState = {
    daysList: [],
    modeList: getDisplayModes(),
    selectedDay: moment().startOf("day"),
    currentModeId: 0,
    currentDay: null,
    interventions: [],
    sortingModes: getSortingModes(),
    blocTypes: [],
    sortingModeId: 0,
    imputationRedirectionModalOpenned: false,
    displayEndedInterventions: false,
    selectedTechnicianId: ALL_SELECT_OPTION,
    blocsHeight: {},
    filteredAndSortedInterventions: [],
    displayOnlyIfGotCerfa: false,
    searchInput: null,
};

const interventionInitialState = {
    currentIntervention: null,
    preview: false,
    controlSignature: false,
    signature: false,
    blocs: [],
    currentTimeSlot: null,
    updatingBloc: null,
    expandedBloc: null,
};

export function interventions(state = initialState, action) {
    switch (action.type) {
        case SET_DAYS_LIST:
            return setValue(state, ["daysList"], action.daysList);
        case SET_CURRENT_DAY:
            return setValue(state, ["currentDay"], action.currentDay);
        case SET_SELECTED_DAY:
            return setValue(state, ["selectedDay"], action.selectedDay);
        case SET_INTERVENTIONS:
            return setValue(state, ["interventions"], action.interventions);
        case SET_FILTERED_AND_SORTED_INTERVENTIONS:
            return setValue(state, ["filteredAndSortedInterventions"], action.interventions);
        case SET_ORDER_BY:
            return setValue(state, ["sortingModeId"], action.orderBy);
        case SET_SELECTED_DISPLAY_MODE:
            return setValue(state, ["currentModeId"], action.currentModeId);
        case SET_INTERVENTIONS_BLOC_TYPES:
            return setValue(state, ["blocTypes"], action.blocTypes);
        case SET_DISPLAY_ENDED_INTERVENTIONS:
            return setValue(state, ["displayEndedInterventions"], action.displayEndedInterventions);
        case SET_SELECTED_TECHNICIAN_ID:
            return setValue(state, ["selectedTechnicianId"], action.selectedTechnicianId);
        case SET_IMPUTATION_REDIRECTION:
            return setValue(state, ["imputationRedirectionModalOpenned"], action.imputationRedirectionModalOpenned);
        case SET_BLOCS_HEIGHT:
            return setValue(state, ["blocsHeight"], Object.assign(action.blocsHeight, state.blocsHeight));
        case SET_DISPLAY_ONLY_IF_GOT_CERFA:
            return setValue(state, ["displayOnlyIfGotCerfa"], action.displayOnlyIfGotCerfa);
        case SEARCH_BY_INTERVENTION_NUMBER:
            return setValue(state, ["searchInput"], action.searchInput);
        default:
            return state;
    }
}

export function intervention(state = interventionInitialState, action) {
    switch (action.type) {
        case SET_CURRENT_INTERVENTION:
            return setValue(state, ["currentIntervention"], action.currentIntervention);
        case SET_BLOCS:
            return setValue(state, ["blocs"], action.blocs);
        case SET_PREVIEW:
            return setValue(state, ["preview"], action.preview);
        case SET_CONTROL_SIGNATURE:
            return setValue(state, ["controlSignature"], action.controlSignature);
        case SET_SIGNATURE:
            return setValue(state, ["signature"], action.signature);
        case SET_CURRENT_TIME_SLOT:
            return setValue(state, ["currentTimeSlot"], action.currentTimeSlot);
        case SET_UPDATING_BLOC:
            return setValue(state, ["updatingBloc"], action.updatingBloc);
        case SET_EXPANDED_BLOC:
            return setValue(state, ["expandedBloc"], action.expandedBloc);
        default:
            return state;
    }
}
